import { render } from "./LoginView.vue?vue&type=template&id=f8c575ee&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=f8c575ee&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c575ee"]])

export default __exports__